import { useEffect, useMemo, useState } from 'react';
import ReusableTable from '../common/reusableTable';
import { useUser } from '../../context/userContext';
import { getAllWebbeyCommission } from '../../api/salesCommission';
import { handlePriceWithRM } from '../../utils/priceUtils';

export default function WebbeyCommissionList() {
    const { user } = useUser();
    const [webbeyCommissionList, setWebbeyCommissionList] = useState([]);


    useEffect(() => {
        const fetchAllWebbeyCommission = async () => {
            if (user?.userId === undefined || user?.userId === null) {
                return;
            }

            try {
                const response = await getAllWebbeyCommission();
                setWebbeyCommissionList(response.data);
            }
            catch (error) {
                console.error("Error fetching commission data:", error);
            }
        };
        fetchAllWebbeyCommission();
    }, [user?.userId]);

    const columns = useMemo(() => [
        {
            header: 'Sales ID',
            accessorKey: 'salesId',
        },
        {
            header: 'Customer Name',
            accessorKey: 'customerName',
        },
        {
            header: 'Commission',
            accessorFn: row => row.webbeyComm,
            Cell: ({ row }) => {
                const cp = row.original;
                if (!cp || cp.webbeyComm == null) {
                    return null
                };

                return handlePriceWithRM(
                    cp.webbeyComm
                );
            },
        },
    ],
        []
    );

    return (
        <ReusableTable
            columns={columns}
            data={webbeyCommissionList}
        >
            {/* <EditSalesCommissionModal
                show={showEditCommissionModal}
                onHide={handleCloseEditCommissionModal}
                selectedCommission={selectedCommission}
                onSaved={fetchCommissionProgress}
            /> */}
        </ReusableTable>
    );
}